import { Box, Grid, Typography } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import emailValidator from 'email-validator'
import { ChangeEvent, FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import Card from '@/components/card'
import InputText from '@/components/input-text'
import { env } from '@/config/env'
import { routes } from '@/routes/config'
import { changePasswordByEmail } from '@/services/change-password-by-email'

import { useStyles } from './styles'

export default function PasswordRecovery() {
  const classes = useStyles()
  const [email, setEmail] = useState({
    value: '',
    isValid: true,
    helpMessage: '',
  })
  const [isRequestSending, setIsRequestSending] = useState(false)
  const [isRecoverySent, setIsRecoverySent] = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!email.isValid || !email.value.trim()) return

    setIsRequestSending(true)

    try {
      await changePasswordByEmail(email.value)
      setIsRecoverySent(true)
    } catch (err) {
      setEmail((prevState) => ({
        ...prevState,
        isValid: false,
        helpMessage: 'Houve um problema, tente mais tarde',
      }))
    } finally {
      setIsRequestSending(false)
    }
  }

  function handleEmailChange(e: ChangeEvent<HTMLInputElement>) {
    const { value } = e.target
    const isValid = emailValidator.validate(value)

    setEmail({
      value,
      isValid,
      helpMessage: !isValid ? 'E-mail inválido' : '',
    })
  }

  return (
    <Grid container className={classes.main}>
      <Box zIndex={100}>
        <Typography variant='h1'>
          Desenvolvido por <img src='assets/img/new-cromai-logo.svg' alt='' />
        </Typography>
      </Box>

      <Card className={classes.cardContent}>
        {!isRecoverySent ? (
          <>
            <Box
              display='flex'
              gridGap='1rem'
              marginLeft='2rem'
              alignSelf='flex-start'
              alignItems='baseline'
            >
              <Link to={routes.Login()} aria-label='Voltar ao login'>
                <ArrowBackIcon color={'secondary'} />
              </Link>
              <Typography variant='h1'>Recuperar senha</Typography>
            </Box>
            <Typography variant='subtitle1'>
              Esqueceu sua senha? Digite seu e-mail que enviaremos um link para
              definir uma nova senha.
            </Typography>
            <form onSubmit={handleSubmit} noValidate>
              <InputText
                id='email'
                label={'E-mail'}
                type='email'
                value={email.value}
                error={!email.isValid}
                helperText={email.helpMessage}
                onChange={handleEmailChange}
                className={classes.emailInput}
              />
              <Button
                className={classes.submitButton}
                loading={isRequestSending}
                type={'submit'}
              >
                Recuperar senha
              </Button>
            </form>
          </>
        ) : (
          <>
            <Typography variant='h1'>Recuperar senha</Typography>
            <Typography variant='subtitle1'>
              Se o seu e-mail estiver no nosso banco de dados, você receberá um
              link para recuperar sua senha no seu e-mail.
            </Typography>
            <main>
              <div>
                <img
                  src='assets/img/email-notification.svg'
                  alt='Notificação de e-mail'
                />
              </div>
              <Button
                component={Link}
                to={routes.Login()}
                className={classes.backButton}
              >
                Voltar ao início
              </Button>
            </main>
          </>
        )}
        <Typography variant={'caption'} className={classes.softwareVersion}>
          Versão {env.softwareVersion}
        </Typography>
      </Card>
    </Grid>
  )
}
